import { render, staticRenderFns } from "./RatingCarousel.vue?vue&type=template&id=55e623f3&scoped=true&"
import script from "./RatingCarousel.vue?vue&type=script&lang=js&"
export * from "./RatingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./RatingCarousel.vue?vue&type=style&index=0&id=55e623f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e623f3",
  null
  
)

export default component.exports